import React from 'react';

const TabNav = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab)}
                        className={`
                            whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                            ${activeTab?.id === tab.id
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }
                        `}
                    >
                        {tab.display}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default TabNav;